import axios from 'axios';

function ownerPath(ownerType, ownerId) {
  const resource = ownerType === 'project' ? 'projects' : 'deals';
  return `/${resource}/${ownerId}/documents`;
}

export const documentService = {
  async list(ownerType, ownerId) {
    const response = await axios.get(ownerPath(ownerType, ownerId));
    return response.data;
  },

  async upload(ownerType, ownerId, file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(ownerPath(ownerType, ownerId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
    return response.data;
  },

  async remove(ownerType, ownerId, documentId) {
    await axios.delete(`${ownerPath(ownerType, ownerId)}/${documentId}`);
  },
};

export default documentService;
